import { render, staticRenderFns } from "./doorCard.vue?vue&type=template&id=6b99851b&scoped=true&"
import script from "./doorCard.vue?vue&type=script&lang=js&"
export * from "./doorCard.vue?vue&type=script&lang=js&"
import style0 from "./doorCard.vue?vue&type=style&index=0&id=6b99851b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99851b",
  null
  
)

export default component.exports